<script lang="ts">
	import CollapsibleCard from '#lib/components/CollapsibleCard.svelte';
	import type { HDGameReportResponseData } from '../types/responses/GameReport.js';

	let { game }: { game: HDGameReportResponseData } = $props();

	let hasLinesmen = $derived(
		game.gameData.gameOfficials.linesman1.lastname !== '' &&
			game.gameData.gameOfficials.linesman2.lastname !== ''
	);

	$inspect(hasLinesmen);
</script>

<CollapsibleCard title="Spieloffizielle" open>
	<div class="flex gap-1">
		<div class="basis-1/2 font-bold uppercase">1. Schiedsrichter:</div>
		<div class="basis-1/2">
			<span class="uppercase">{game.gameData.gameOfficials.ref1.lastname}</span>
			{game.gameData.gameOfficials.ref1.firstname.charAt(0)}.
		</div>
	</div>
	<div class="flex gap-1">
		<div class="basis-1/2 font-bold uppercase">2. Schiedsrichter:</div>
		<div class="basis-1/2">
			<span class="uppercase">{game.gameData.gameOfficials.ref2.lastname}</span>
			{game.gameData.gameOfficials.ref2.firstname.charAt(0)}.
		</div>
	</div>
	<div class="flex gap-1">
		<div class="basis-1/2 font-bold uppercase">1. Linienrichter:</div>
		<div class="basis-1/2">
			{#if hasLinesmen}
				<span>
					<span class="uppercase">{game.gameData.gameOfficials.linesman1.lastname}</span>
					{game.gameData.gameOfficials.linesman1.firstname.charAt(0)}.
				</span>
			{:else}
				<span> - </span>
			{/if}
		</div>
	</div>
	<div class="flex gap-1">
		<div class="basis-1/2 font-bold uppercase">2. Linienrichter:</div>
		<div class="basis-1/2">
			{#if hasLinesmen}
				<span>
					<span class="uppercase">{game.gameData.gameOfficials.linesman2.lastname}</span>
					{game.gameData.gameOfficials.linesman2.firstname.charAt(0)}.
				</span>
			{:else}
				<span> - </span>
			{/if}
		</div>
	</div>
	<div class="flex gap-1">
		<div class="basis-1/2 font-bold uppercase">Cheftrainer {game.gameData.homeTeamShortname}:</div>
		<div class="basis-1/2">
			<span class="uppercase">{game.gameData.teamOfficials.headcoachhome.lastname}</span>
			{game.gameData.teamOfficials.headcoachhome.firstname.charAt(0)}.
		</div>
	</div>
	<div class="flex gap-1">
		<div class="basis-1/2 font-bold uppercase">Cheftrainer {game.gameData.awayTeamShortname}:</div>
		<div class="basis-1/2">
			<span class="uppercase">{game.gameData.teamOfficials.headcoachaway.lastname}</span>
			{game.gameData.teamOfficials.headcoachaway.firstname.charAt(0)}.
		</div>
	</div>
</CollapsibleCard>
